import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { UserRepositoryInterface } from '@/data/persistences/repositories/contracts/UserRepositoryInterface'
import { User, Export } from '@/domain/entities/User'
import { UserDataMapper } from '@/data/persistences/mappers/UserDataMapper'
import {
  PostUserInterface,
  DeleteUserInterface,
  UpdateUserInterface,
  PostImportFile,
} from '@/data/payload/contracts/UserRequest'
import {
  UserApiRequest,
  UpdateUserRequest,
  PostImportRequest,
  UpdateUserDnetRequest,
} from '@/data/payload/api/UserRequest'
export class UserApiRepository implements UserRepositoryInterface {
  private service: ApiService
  private mapper: UserDataMapper

  constructor(service: ApiService, mapper: UserDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<User> {
    const resp = await this.service.invoke('get', Endpoints.Route.USERS, params)
    return this.mapper.convertUserListFromApi(resp)
  }

  public async getExport(params: Object): Promise<Export> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.EXPORT,
      params
    )
    return this.mapper.convertExportFileFromAPi(resp)
  }

  public async postImport(payload: PostImportFile): Promise<Export> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.IMPORT,
      undefined,
      payload as PostImportRequest
    )
    return this.mapper.convertExportFileFromAPi(resp)
  }

  public async post(payload: PostUserInterface): Promise<User> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.USERS,
      undefined,
      payload as UserApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(payload: UpdateUserInterface, id: number): Promise<User> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.USERS}/${id}`,
      undefined,
      payload as UpdateUserRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async updateDnet(payload: UpdateUserInterface): Promise<User> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.USERSDNET}`,
      undefined,
      payload as UpdateUserDnetRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async delete(payload: DeleteUserInterface): Promise<User> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.USERS_DELETE,
      undefined,
      payload as UserApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
